import styled from 'styled-components';

const ListContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
`;

const Item = styled.div<{ selected?: boolean }>`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    width: 166px;
    height: 136px;
    padding: 32px 24px;
    background: ${(props) => props.theme['Surface/page']};
    border-radius: 12px;
    border: 1px solid ${(props) => props.theme['Borders/control']};
    cursor: pointer;

    &:hover {
        border-color: ${(props) => props.theme['Borders/active']};
        background: ${(props) => props.theme['Surface/secondary']};
    }

    &:active {
        border-color: ${(props) => props.theme['Borders/active']};
        background: ${(props) => props.theme['Surface/secondary']};
    }

    ${(props) =>
        props.selected &&
        `
        border-color: ${props.theme['Borders/active']};
        background: ${props.theme['Surface/secondary']};
    `}
`;

const Title = styled.span`
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
`;

const Icon = styled.div`
    height: 32px;
    .material-symbols-outlined {
        font-size: 30px;
    }
`;

type BigTileProps = {
    items: { id: string; icon: any; title: string }[];
    selected?: string;
    handleClick: (id: string) => void;
};
export const BigTiles = ({ items, handleClick, selected }: BigTileProps) => (
    <ListContainer>
        {items.map((item, index) => (
            <Item
                data-test-id={`big-tile-${item.id}`}
                key={index}
                onClick={() => handleClick(item.id)}
                selected={selected === item.id}
            >
                <Icon>{item.icon}</Icon>
                <Title>{item.title}</Title>
            </Item>
        ))}
    </ListContainer>
);
